import { Backdrop, Box, CircularProgress } from '@mui/material';
import React, { type FC } from 'react';
interface LoadingProps {
  overlay?: boolean;
  backdrop?: boolean;
}
const Loading: FC<LoadingProps> = ({ overlay = false, backdrop = false }) => {
  if (backdrop) {
    return (
      <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
        <CircularProgress />
      </Backdrop>
    );
  }

  return (
    <Box
      sx={{
        ...(overlay && { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }),
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
        pointerEvents: 'none',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Loading;
